import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { CustomFieldsInformation } from '../types/CustomFieldsInformation';
import { CustomFieldsFormDataProviderFactory } from '../factory/CustomFieldsFormDataProviderFactory';
import { CustomFieldsFormBaseDataProvider } from '../dataProvider/CustomFieldsFormBaseDataProvider';

export class CustomFieldsFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CustomFieldsFormDataProviderFactory;
  public dataProvider: CustomFieldsFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CustomFieldsFormDataProviderFactory(),
    });
  }

  public async getCustomFields(managedCompanyId: string): Promise<CustomFieldsInformation> {
    return this.dataProvider.getCustomFields(managedCompanyId);
  }
}
